import React, { useState } from "react";
import { Auth, API } from "aws-amplify";
import { useHistory, useLocation, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { BsCheck } from "react-icons/bs";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import admins from "../admins";
import config from '../config';
import "./Login.css";

export default function RequestLoginId() {
  const history = useHistory();
  const { userHasAuthenticated, userProfile, setUserProfile, setIsAdmin } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  const [mailSent, setMailSent] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [isSendingMail, setIsSendingMail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerTitle, setHeaderTitle] = useState("ログインIDリクエスト画面");

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    email: ""
  },
  {
    email: {n:"", f: (value) => { console.log(value); return '' }}
  });

  function validateEmailForm() {
    return fields.email.length > 0;
  }

  const mailBody = () => {/*
Emailアドレス："{{email}}" のご登録ユーザー様
{{}}
以下のログインIDのご登録がありましたので、ご確認ください。
{{ids}}
  */};

  async function handleRequestClick(event) {
    event.preventDefault();

    setIsSendingMail(true);
    const b = mailBody.toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
    console.log(b);
    try {
      const ids = await API.get('sakurajima', `/memberIds?ml=${fields.email}`);
      console.log(ids);
      const ba = b.replaceAll('{{email}}', fields.email).replaceAll('{{ids}}', ids.join("\n")).replaceAll('{{}}', "\n").split("\n");
      console.log(ba);

      let bod = [];
      for (let i in ba) {
        bod.push(ba[i].trim());
      }

      console.log(bod.join("\n"));
      setIsSendingMail(false);
      if (ids.length == 0) {
        setErrorMessage('ユーザー登録情報が見つかりませんでした。');
        return false;
      }

      const subj = '会員専用ページログインのご案内（正会員） 【日本臨床スポーツ医学会】';
      const r = await sendMail({
	subject: subj,
	from: config.mail.source,
	to: [fields.email],
	mailBody:bod.join("\n"),
        enableLog: false,
        fronEmail: config.mail.source,
        fromName: '【日本臨床スポーツ医学会】'
      });
      console.log(r);
      if (r.statusCode == 200) {
        setMailSent(true);
        setHeaderTitle('ログインIDメール送信完了');
      } else if (r.statusCode == 500) {
        alert(r.body);
      } else {
        onError('ユーザーID通知メールを送信中にエラーが発生しました。');
      }

    } catch (error) {
      onError(error);
      setIsSendingMail(false);
    }
  }

  const sendMail = (data) => {
    return API.post('sakurajima', '/sendmail', {
      body: data
    });
  };

  function renderRequestLoginIdForm() {
    return (
      <>
      <p>ご登録のメールアドレスを入力してください。</p>
      <Form onSubmit={handleRequestClick}>
        <Form.Group size="lg" controlId="email">
          <Form.Label>メールアドレス</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            value={fields.email}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <LoaderButton
          block
          type="submit"
          size="lg"
          isLoading={isSendingMail}
          disabled={!validateEmailForm()}
        >
          送信
        </LoaderButton>
      </Form>
      <p id="formErrorMessage" className="errorMessages">{errorMessage}</p>
      </>
    );
  }

  function renderSuccessMessage() {
    return (
      <div className="success">
        <p>ご登録のメールアドレス宛にログインIDを送信いたしました。.</p>
        <p>メールの内容をご確認後
          <Link to="/login/reset">
            パスワードリセット画面
          </Link>
          よりパスワードの更新をおこなってください。
        </p>
      </div>
    );
  }


  return (
    <div className="Login">

      <h1 id="page_title">{headerTitle}</h1> 
      <div id="sub_page">
      <div id="mypage" className="login">
      <section>
	  {!mailSent 
            ? renderRequestLoginIdForm()
           : renderSuccessMessage() }
      </section>
      </div>
      </div>
    </div>
  );
}
